import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'user',
  type: 'user--user',
  attributes: {
    name: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'name',
    },
    email: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'mail',
    },
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    id: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
  },
  relationships: {},
};
export const UserService = createService(base, configuration, API_CONFIG.API);
export const UserModule = createModule(UserService, true);



// WEBPACK FOOTER //
// ./src/models/user.js